<template>
  <div data-v-249f9abc="" class="wrapper clearfix">
    <div data-v-1dc60391="" data-v-249f9abc="" class="content clearfix">
      <div data-v-1dc60391="" class="main">
        <div data-v-064cc9e2="" data-v-1dc60391="" >
          <h1 data-v-064cc9e2="">
            用水报装
          </h1>
          <!-- <div data-v-064cc9e2="" class="detail">
            <h3 data-v-064cc9e2="" class="mt20 gc3">请选择客户类型</h3>
            <div data-v-064cc9e2="" class="bind-box">
              <div data-v-064cc9e2="" class="basic" @click="regretType=0">
                <label data-v-064cc9e2="" role="radio" tabindex="0" class="el-radio" :class="{'is-checked':regretType===0}">
                  <span class="el-radio__input" :class="{'is-checked':regretType===0}">
                    <span class="el-radio__inner"></span>
                    <input type="radio" aria-hidden="true" tabindex="-1" class="el-radio__original" value="1">
                  </span>
                  <span class="el-radio__label">个人客户用水报装</span>
                </label>
                <div data-v-064cc9e2="" class="info"><span data-v-064cc9e2="">需提供相关证明资料</span> <i data-v-064cc9e2="" class="el-icon-arrow-right"></i></div>
              </div>
              <div data-v-064cc9e2="" class="more" v-if="regretType===0">
                <div data-v-064cc9e2="" class="download-list">
                  <ul data-v-064cc9e2="">
                    <li data-v-064cc9e2=""><span data-v-064cc9e2="">业主身份证</span> <span data-v-064cc9e2="" class="span2">个人身份证明</span></li>
                    <li data-v-064cc9e2=""><span data-v-064cc9e2="">产权证明</span> <span data-v-064cc9e2="" class="span2">用水地址产权证明</span></li>
                    <li data-v-064cc9e2=""><span data-v-064cc9e2="">个人银行卡</span> <span data-v-064cc9e2="" class="span2">办理银行代扣水费</span></li>
                  </ul>
                </div>
                <div data-v-064cc9e2="" class="mt20 understand" :class="{active:isOk}">
                  <span data-v-064cc9e2="" class="check_icon" @click="isOk=!isOk">
                    <i data-v-064cc9e2="" class="el-icon-check"></i>
                  </span>
                  <span data-v-064cc9e2="" class="isAgree">已了解办理流程并保证所提交资料真实有效。</span>
                </div>
                <div data-v-064cc9e2="" class="isAgree" style="padding-top: 20px; line-height: 24px;">
                  本次业务办理将留存业主刷脸时提供的姓名、手机号、身份证号。
                </div>
              </div>
            </div>
            <div data-v-064cc9e2="" class="bind-box">
              <div data-v-064cc9e2="" class="basic" @click="regretType=1;subType=''">
                <label data-v-064cc9e2="" role="radio" tabindex="0" class="el-radio" :class="{'is-checked':regretType===1}">
                  <span class="el-radio__input" :class="{'is-checked':regretType===1}">
                    <span class="el-radio__inner"></span>
                    <input type="radio" aria-hidden="true" tabindex="-1" class="el-radio__original" value="2"></span>
                  <span class="el-radio__label">单位客户供排水报装</span>
                </label>
                <div data-v-064cc9e2="" class="info">
                  <span data-v-064cc9e2="">选择供排水报装类型</span>
                  <i data-v-064cc9e2="" class="el-icon-arrow-right"></i>
                </div>
              </div>
              <div data-v-064cc9e2="" class="more" v-if="regretType===1">
                <div data-v-064cc9e2="" class="download-list">
                  <ul data-v-064cc9e2="">
                    <li data-v-064cc9e2="" @click="subType=0">
                      <label :class="{'is-checked':subType===0}" data-v-064cc9e2="" role="radio" tabindex="0" class="el-radio">
                        <span class="el-radio__input" :class="{'is-checked':subType===0}"><span class="el-radio__inner"></span><input type="radio" aria-hidden="true" tabindex="-1"
                                 class="el-radio__original" value="1"></span><span class="el-radio__label">单位客户正式供排水报装
                          
                        </span></label>
                    </li>
                    <li data-v-064cc9e2="" @click="subType=1">
                      <label :class="{'is-checked':subType===1}" data-v-064cc9e2="" role="radio" tabindex="0" class="el-radio">
                        <span class="el-radio__input" :class="{'is-checked':subType===1}">
                          <span class="el-radio__inner"></span>
                          <input type="radio" aria-hidden="true" tabindex="-1" class="el-radio__original" value="2"></span><span class="el-radio__label">建设项目供排水报装
                          
                        </span></label>
                    </li>
                    <li data-v-064cc9e2="" @click="subType=2">
                      <label :class="{'is-checked':subType===2}" data-v-064cc9e2="" role="radio" tabindex="0" class="el-radio">
                        <span class="el-radio__input" :class="{'is-checked':subType===2}">
                          <span class="el-radio__inner"></span>
                          <input type="radio" aria-hidden="true" tabindex="-1" class="el-radio__original" value="3"></span><span class="el-radio__label">环卫、绿化及消防用水
                          
                        </span></label>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div> -->
          
          <!-- <div data-v-064cc9e2="" class="greyBtnWrap">
            <button data-v-064cc9e2="" :disabled="disabled" type="button" class="el-button el-button--primary " :class="{'is-disabled':disabled}" @click="toRegret">
              <span>确认并继续</span>
            </button>
          </div> -->
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="个人" name="first">
              <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                <el-form-item label="姓名：" prop="name" class="cl_one">
                    <el-input v-model="ruleForm.name" class="jianwidth" placeholder="请输入姓名"></el-input>
                </el-form-item>
                
                <el-form-item label="地址：" prop="dizhi">
                    <el-input v-model="ruleForm.dizhi" class="jianwidth" placeholder="请输入地址"></el-input>
                </el-form-item>
                <el-form-item label="联系方式：" prop="num">
                    <el-input v-model="ruleForm.num" class="jianwidth" placeholder="请输入联系方式"></el-input>
                </el-form-item>
                <el-form-item label="身份证号：" prop="ID_number">
                  <el-input
                    v-model="ruleForm.ID_number"
                    class="jianwidth"
                    placeholder="请输入身份证号"
                  ></el-input>
                </el-form-item>
                <!-- <el-form-item label="银行卡号" prop="kahao">
                    <el-input v-model="ruleForm.kahao" class="jianwidth" placeholder="请输入详细地址"></el-input>
                </el-form-item> -->
                <el-form-item label="身份证正面：" prop="region1" class="cl_one">
                  <el-upload
                    action="https://jsonplaceholder.typicode.com/posts/"
                    list-type="picture-card"
                    :on-preview="handlePictureCardPreview"
                    :on-remove="handleRemove">
                    <i class="el-icon-plus"></i>
                  </el-upload>
                  <el-dialog :visible.sync="dialogVisible">
                    <img width="100%" :src="dialogImageUrl" alt="">
                  </el-dialog>
                </el-form-item>
                <el-form-item label="身份证反面：" prop="region3" class="jiakuan">
                  <el-upload
                    action="https://jsonplaceholder.typicode.com/posts/"
                    list-type="picture-card"
                    :on-preview="handlePictureCardPreview"
                    :on-remove="handleRemove">
                    <i class="el-icon-plus"></i>
                  </el-upload>
                  <el-dialog :visible.sync="dialogVisible">
                    <img width="100%" :src="dialogImageUrl" alt="">
                  </el-dialog>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" :plain="true" @click="submitForm('ruleForm')">提交</el-button>
                </el-form-item>
              </el-form>
            </el-tab-pane>
            <el-tab-pane label="企业" name="second" >
              <el-form
                :model="ruleForm_qi"
                :rules="rulesly"
                ref="ruleForm_qi"
                label-width="180px"
                class="demo-ruleForm"
              >
                <el-form-item label="单位名字：" prop="name_qi" class="cl_one">
                  <el-input
                    v-model="ruleForm_qi.name_qi"
                    class="jianwidth"
                    placeholder="请输入单位名字"
                  ></el-input>
                </el-form-item>
                <el-form-item label="地址：" prop="dizhi">
                    <el-input v-model="ruleForm_qi.dizhi" class="jianwidth" placeholder="请输入地址"></el-input>
                </el-form-item>
                <el-form-item label="联系方式：" prop="jblxfs_qi">
                  <el-input
                    v-model="ruleForm_qi.jblxfs_qi"
                    class="jianwidth"
                    placeholder="请输入联系方式"
                  ></el-input>
                </el-form-item>
                <el-form-item label="组织机构类型：" prop="zzjglx_qi">
                  <el-input
                    v-model="ruleForm_qi.zzjglx_qi"
                    class="jianwidth"
                    disabled
                    placeholder="请输入组织机构类型"
                  ></el-input>
                </el-form-item>
                <el-form-item label="营业执照：" prop="zjzm_qi" class="cl_one">
                  <el-upload
                    action="https://jsonplaceholder.typicode.com/posts/"
                    list-type="picture-card"
                    :on-preview="handlePictureCardPreview"
                    :on-remove="handleRemove"
                  >
                    <i class="el-icon-plus"></i>
                  </el-upload>
                  <el-dialog :visible.sync="dialogVisible">
                    <img width="100%" :src="dialogImageUrl" alt="" />
                  </el-dialog>
                </el-form-item>
                <!-- <el-form-item label="联系人：" prop="jingbani_qi">
                  <el-input
                    v-model="ruleForm.jingbani_qi"
                    class="jianwidth"
                    placeholder="请输入联系人"
                  ></el-input>
                </el-form-item> -->
                
                <!-- <el-form-item label="产权证明" prop="chanquan_qi" class="jiakuan">
                  <el-upload
                    action="https://jsonplaceholder.typicode.com/posts/"
                    list-type="picture-card"
                    :on-preview="handlePictureCardPreview"
                    :on-remove="handleRemove"
                  >
                    <i class="el-icon-plus"></i>
                  </el-upload>
                  <el-dialog :visible.sync="dialogVisible">
                    <img width="100%" :src="dialogImageUrl" alt="" />
                  </el-dialog>
                </el-form-item> -->
                <!-- <el-form-item label="单位名称" prop="num_qi">
                  <el-input
                    v-model="ruleForm.num_qi"
                    class="jianwidth"
                    placeholder="请输入单位全称"
                  ></el-input>
                </el-form-item> -->
                
                <!-- <el-form-item label="证件号码" prop="sfzhnum_qi">
                  <el-input
                    v-model="ruleForm.sfzhnum_qi"
                    class="jianwidth"
                    placeholder="请输入证件号码"
                  ></el-input>
                </el-form-item> -->
                
                <el-form-item>
                  <el-button type="primary" :plain="true" @click="submitForm('ruleForm')">提交</el-button>
                  <!-- <el-button type="primary" @click="submitForm('ruleForm')"
                    >提交</el-button
                  > -->
                </el-form-item>
              </el-form>
            </el-tab-pane>
          </el-tabs>
        
        </div>
      </div>
      <businessAside />
    </div>
  </div>

</template>

<script>
import businessAside from '../../components/aside'
export default {
  data() {
    return {
      activeName: "first",
      dialogImageUrl: '',
      dialogVisible: false,
      fileList:'',
      textarea: '',
      value1:'',
      ruleForm: {
          name: '',
          num:'',
          dizhi:'',
          region1: '',
          region2: '',
          region3: '',
          miaoshu:'',
          value:'',
          resource: '',
          ID_number:'',
        },
      ruleForm_qi: {
        // frontOfIDCard:'',//身份证正面
        // backOfIDCard: "",//身份证反面
        // frontOfIDCard_jb:'',//身份证正面
        // backOfIDCard_jb: "",//身份证反面
        name_qi:'',
        dizhi:'',
        jblxfs_qi:'',
        zzjglx_qi:'事业单位',
        sfzhnum_qi:'',
        zjzm_qi:'',
        zjfm_qi:'',
        chanquan_qi:'',
      },
        rules: {
          name: [
            { required: true, message: '请输入姓名', trigger: 'blur' },
            // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
          ],
          num: [
            { required: true, message: '请输入联系方式', trigger: 'blur' },
            // { min: 11, max: 11, message: '11位字符', trigger: 'blur' }
          ],
          miaoshu:[
            { required: true, message: '请上传产权证明', trigger: 'change' }
          ],
          // region1: [
          //   { required: true, message: '请上传身份证有人像的一面', trigger: 'change' }
          // ],
          // region3: [
          //   { required: true, message: '请上传身份证有国徽的一面', trigger: 'change' }
          // ],
          region2: [
            { required: true, message: '请选择所在区域', trigger: 'change' }
          ],
          dizhi: [
            { required: true, message: '请输入地址', trigger: 'change' }
          ],
          kahao: [
            { required: true, message: '请输入银行卡号', trigger: 'change' }
          ],
          resource: [
            { required: true, message: '请选择用户类型', trigger: 'change' }
          ],
        },
        rulesly: {
          zzjglx_qi: [
            { required: true, message: '请选择组织机构类型', trigger: 'change' }
          ],
        name_qi: [{ required: true, message: "请输入单位名字", trigger: "blur" }],
        jingbani_qi: [
          { required: true, message: "请输入联系人", trigger: "blur" },
          { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" },
        ],
        jblxfs_qi: [
          { required: true, message: "请输入联系方式", trigger: "blur" },
          { min: 11, max: 11, message: "11位字符", trigger: "blur" },
        ],
        sfzhnum_qi:[
          { required: true, message: "请输入身份证号", trigger: "change" },
        ],
        chanquan_qi: [
          { required: true, message: "请上传产权证明", trigger: "change" },
        ],
        zjzm_qi: [
          {
            required: true,
            message: "请上传营业执照",
            trigger: "change",
          },
        ],
        zjfm_qi: [
          {
            required: true,
            message: "请上传现单位营业执照",
            trigger: "change",
          },
        ],
        frontOfIDCard: [
            { required: true, message: '请上传身份证有人像的一面', trigger: 'change' }
        ],
        backOfIDCard: [
          { required: true, message: '请上传身份证有国徽的一面', trigger: 'change' }
        ],
        frontOfIDCard_jb: [
            { required: true, message: '请上传身份证有人像的一面', trigger: 'change' }
        ],
        backOfIDCard_jb: [
          { required: true, message: '请上传身份证有国徽的一面', trigger: 'change' }
        ],
        dizhi: [
            { required: true, message: '请输入地址', trigger: 'change' }
          ],
      },
      regretType: '',
      subType: '',
      disabled: true,
      isOk: false,
    }
  },
  watch: {
    subType(n) {
      if ([0, 1, 2].indexOf(n) !== -1) {
        this.disabled = false
      } else {
        this.disabled = true
      }
      console.log(this.disabled)
    },
    isOk(n) {
      if (n) {
        this.disabled = false
      } else {
        this.disabled = true
      }
      console.log(this.disabled)
    },
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    handleRemove(file, fileList) {
        console.log(file, fileList);
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
     handleChange(file, fileList) {
        this.fileList = fileList.slice(-3);
      },
    // submitForm(formName) {
    //     this.$refs[formName].validate((valid) => {
    //       if (valid) {
    //         alert('提交成功!');
    //       } else {
    //         console.log('error submit!!');
    //         return false;
    //       }
    //     });
    //   },
    submitForm() {
        // this.$refs[formName].validate((valid) => {
        //   if (valid) {
            this.$message({
          message: '提交成功,请勿重复此操作!',
          type: 'success'
        });
        //   } else {
        //     console.log('error submit!!');
        //     return false;
        //   }
        // });
      },
    toRegret() {
      const BASE_PATH = window.location.href.split('#')[0]
      window.location.href = BASE_PATH + '#' + '/regret_pe'
    },
  },
  components: {
    businessAside,
  },
}
</script>

<style>
</style>